/* eslint-disable no-unused-vars */

import { useQuery } from "react-query";
import axios from "axios";
import { baseURL } from "../constants/api";
import { getHeaders } from "./helper";
import useProfile from "./useProfile";

const getData = async (props, token) => {
  const config = getHeaders();

  if (token) {
    config.headers.ab_token = token;
  }

  const { data } = await axios.post(
    baseURL + "masters/productDetails",
    props,
    config
  );
  return data;
};

export default function useProduct(props) {
  const { data } = useProfile();
  return useQuery("product", () => getData(props, data?.data?.token));
}
